<h3 mat-dialog-title>{{ isEdit ? 'Edit' : 'Add' }} WhatsApp Template (PinBot)</h3>
<form [formGroup]="templateForm" (ngSubmit)="submit()">
  <div mat-dialog-content>
    <div class="mat-input-group">
      <mat-form-field>
        <input matInput placeholder="Template Name" formControlName="name">
      </mat-form-field>
    </div>
    <div class="mat-input-group">
      <mat-form-field>
        <mat-select placeholder="Category" formControlName="category">
          <mat-option *ngFor="let c of categoryOptions" [value]="c">{{ c }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="mat-input-group">
      <mat-form-field>
        <input matInput placeholder="Language (e.g. en_US)" formControlName="language">
      </mat-form-field>
    </div>
    <div class="mat-input-group">
      <mat-form-field>
        <textarea matInput rows="6" placeholder="Body Text" formControlName="body"></textarea>
      </mat-form-field>
    </div>
    <div>
      <h4>Placeholder bindings</h4>
      <p *ngIf="!placeholderBindings.length">Add placeholders such as {{ '{{1}}' }} to the body to choose their customer-field bindings.</p>
      <div *ngIf="placeholderBindings.length" formArrayName="placeholderBindings">
        <p>Choose the customer field to send for each template placeholder.</p>
        <div *ngFor="let binding of placeholderBindings.controls; let i = index" [formGroupName]="i" class="mat-input-group">
          <mat-form-field>
            <input matInput formControlName="token" readonly>
          </mat-form-field>
          <mat-form-field>
            <mat-select placeholder="Customer field" formControlName="field">
              <mat-option *ngFor="let field of contactFieldOptions" [value]="field.value">{{ field.label }}</mat-option>
            </mat-select>
            <mat-error *ngIf="binding.get('field').hasError('required')">Select a customer field.</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="mat-input-group">
      <mat-form-field>
        <textarea matInput rows="5" placeholder="Additional template options (JSON)" formControlName="extraJson"></textarea>
        <mat-hint>Use this for filename, buttons, lto, location, or cards. Placeholder bindings are added automatically.</mat-hint>
        <mat-error *ngIf="templateForm.get('extraJson').hasError('invalidExtraJson')">Enter a JSON object.</mat-error>
      </mat-form-field>
    </div>
    <div class="mat-input-group">
      <mat-form-field>
        <textarea
          matInput
          rows="5"
          placeholder="Prepared extra JSON sent to the backend"
          [value]="preparedExtraJson"
          readonly
        ></textarea>
        <mat-hint>This value is sent as <code>extraJson</code> when the template is saved.</mat-hint>
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-stroked-button type="button" (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="templateForm.invalid">Save</button>
  </div>
</form>
